import { motion } from "framer-motion";
import { StyledButton } from "./Button.styles";

export default function Button({
  title,
  disabled,
  leftIcon,
  rightIcon,
  loading,
  onClick,
  lightColor,
  darkColor,
  width,
  type,
  ...props
}) {
  return loading ? (
    <StyledButton
      type={type}
      style={{ width: width }}
      disabled
      $darkColor={darkColor}
      $lightColor={lightColor}
      {...props}
    >
      <l-line-spinner size="16" stroke="2" speed="1" color={darkColor} />
    </StyledButton>
  ) : (
    <StyledButton
      type={type}
      style={{ width: width }}
      as={motion.button}
      whileHover={{
        scale: 1.015,
        y: -1.5,
        boxShadow: "0 6px 14px rgba(0,0,0,0.18)",
      }}
      transition={{ type: "spring", stiffness: 300 }}
      disabled={disabled}
      $darkColor={darkColor}
      $lightColor={lightColor}
      onClick={onClick}
      {...props}
    >
      {leftIcon}
      {title}
      {rightIcon}
    </StyledButton>
  );
}
